import { Component, type ReactNode } from "react";

export function DocsLoadError() {
  return (
    <div className="docs-error" role="alert">
      <p>Couldn't load documentation. Check your connection and reload.</p>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}

/** Catches a failed lazy chunk (e.g. after a deploy replaced it) so the page never goes blank. */
export class DocsErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? <DocsLoadError /> : this.props.children; }
}
